import { useMemo } from 'react';

import { useGetBalance } from '@/api/pactswap/generated/api';

import { useCoinwebWallet } from '../hooks/useCoinwebWallet';

const SHARD = 'BNB';

export function useCoinwebBalance() {
  const { address } = useCoinwebWallet();

  const strippedAddress = useMemo(() => (address?.startsWith('0x') ? address.slice(2) : address) ?? '', [address]);
  const backendUrl = (import.meta.env.VITE_BACKEND_URL as string) || 'https://api-cloud.coinweb.io/wallet';

  return useGetBalance(
    { publicKey: strippedAddress, backendUrl, shard: SHARD },
    {
      query: {
        enabled: !!strippedAddress,
        refetchOnMount: true,
        refetchOnWindowFocus: true,
        refetchInterval: 20_000,
      },
    }
  );
}

export default useCoinwebBalance;
